<template>
  <v-alert :dark="dark"
           text
           class="flex-grow-1"
           icon="mdi-map-marker"
           prominent
  >
    <span v-if="hasPoint">
      {{ $dictionary.get(textInfo) }}
      <b class="d-block">
        {{ textSelected }}
        <v-btn icon small :to="toEdit">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </b>
    </span>
    <span v-else>
      {{ $dictionary.get(textNotSelected) }}
      <Anchor :to="toEdit" :dark="dark" label="click-to-select" />
    </span>
  </v-alert>
</template>

<script>
import Anchor from '@/components/Anchor';

export default {
  name: 'PointInfo',
  components: { Anchor },
  props: {
    delivery: { type: Boolean, default: false }
  },
  computed: {
    dark() { return this.$store.state.theme.mainDark; },
    color() { return this.$store.state.theme.mainColor; },
    hasPoint() {
      const { point, points } = this.$store.state.data;
      if (point === null || !points) return false;
      return points[point] && points[point]._id;
    },
    point() {
      if (!this.hasPoint) return {};
      const { point } = this.$store.state.data;
      return this.$store.state.data.points[point];
    },
    toEdit() {
      return this.delivery ? '/address' : '/pickup';
    },
    textInfo() {
      return this.delivery ? 'info-about-location' : 'info-about-point';
    },
    textSelected() {
      if (this.delivery && this.$store.state.data.address) {
        return this.$store.state.data.address.text;
      }
      const name = this.point.signboard || this.point.name;
      return `${name} ${this.point.address || ''}`;
    },
    textNotSelected() {
      return this.delivery ? 'no-delivery-address' : 'no-pickup-point';
    },
  }
};
</script>
